import {
    Directive,
    OnInit,
    ElementRef,
    HostListener,
    AfterViewInit,
    Input,
    ViewContainerRef,
    TemplateRef
} from '@angular/core';
import {NgControl} from '@angular/forms';
import {CirfConfigService} from "../../cirf/config/cirf-config-service";
import {CirfService} from "../../cirf/cirf.service";
import {CirfFieldStatusType, CirfFieldStatusValue} from "../../cirf/config/cirf-field";

@Directive({selector: '[dp-field-visibility]'})
export class DpFieldVisibilityDirective {

    isUdf : boolean;
    fieldConfig: string

    constructor(
                private elementRef: ElementRef,
                private cirfConfigService: CirfConfigService) {
    }

    @Input('dp-field-visibility')
    set fieldVisibility(fieldConfig: string) {
        if (fieldConfig) {
            this.fieldConfig = fieldConfig
            this.setVisibility();
        }
    }

    @Input('isUdf')
    set isUserDefinedField(isUdf : boolean) {
        if(isUdf) {
            this.isUdf = isUdf;
            this.setVisibility();
        }
    }

    private setVisibility() {
        if (this.cirfConfigService) {
            if (this.fieldConfig.indexOf(';') > -1) {
                if (this.cirfConfigService.areFieldsHidden(this.fieldConfig)) {
                    this.elementRef.nativeElement.style.display = 'none';
                }
            } else {
                if(this.isUdf){
                    if (this.cirfConfigService.isUDFHidden(this.fieldConfig)) {
                        this.elementRef.nativeElement.style.display = 'none';
                    }
                } else {
                    if (this.cirfConfigService.isFieldHidden(this.fieldConfig)) {
                        this.elementRef.nativeElement.style.display = 'none';
                    }
                }
            }
        }
    }
}
